"use strict";

// ---------------------------------------------------
// Dependencies

var _ = require('underscore');

// ---------------------------------------------------
// Module Definition

// This makes the function do nothing on prod/testing environments
// So that we don't generate errors.
var checkProps = module.exports = function () {};

// The block below re-defining the checkProps module gets
// removed on prod/testing environments
/* develblock:start */
/**
 * @module checkProps
 * @type {function}
 * @param {object} propsConfig
 *      An object with keys being the allowed
 *      keys of the 'values' parameter, and the
 *      values being type or constructor function
 * @param {object} values
 *      An object with keys and values being of the
 *      name/type combination specified in the
 *      propsConfig parameter
 * @param {object} errorMessageCallbacks
 *      If you want to replace any of the callbacks
 *      for specific kinds of errors.
 *
 * @property {PropsChecker} PropsChecker
 */
checkProps = module.exports = function (propsConfig, values, errorMessageCallbacks) {
    return new checkProps.PropsChecker(propsConfig, errorMessageCallbacks).checkValues(values);
};
/* develblock:end */

// ---------------------------------------------------
// Define Module Static Properties

/**
 * @class PropsChecker
 * @memberOf module:checkProps
 * @param {object} propsConfig
 * @param {object} options
 * @constructor
 */
var PropsChecker = function (propsConfig, options) {
    options = options || {};
    this.propsConfig = propsConfig || this.propsConfig;
    this.handleTypeErrors = options.handleTypeErrors || this.handleTypeErrors;
    this.supportedError = options.supportedError || this.supportedError;
    this.parentProp = options.parentProp || this.parentProp;
    this._options = options;
};

checkProps.PropsChecker = PropsChecker;

_.extend(PropsChecker.prototype, {

    /**
     * @param {object} errorMessageCallbacks
     * @returns {PropsChecker}
     */
    setErrorMessageCallbacks: function (errorMessageCallbacks) {
        errorMessageCallbacks = errorMessageCallbacks || {};
        return this;
    },

    /**
     * @param {object} values
     * @returns {PropsChecker}
     */
    checkValues: function (values) {
        var propName;

        if (values === null || values === undefined) {
            return this;
        }

        if (typeof values !== 'object') {
            return this.valuesIsObjectError();
        }

        for (propName in values) {
            if (values.hasOwnProperty(propName)) {
                this.checkValueForProp(propName, values);
            }
        }

        return this;
    },

    /**
     * If you want to evaluate a specific property
     * and test it for type errors
     * @param {string} propName
     * @param {object} values
     * @returns {PropsChecker}
     */
    checkValueForProp: function (propName, values) {
        var propsConfig = this.propsConfig;
        var isArray;
        var typeErrors;
        var types;
        var value;

        if (!propsConfig.hasOwnProperty(propName)) {

            this.handleSupportedError(propName);

        } else {

            value = values[propName];
            types = propsConfig[propName];
            isArray = _.isArray(types);

            if (!isArray && typeof types === 'object') {
                new checkProps.PropsChecker(types, this._getOptionsClone(propName)).checkValues(value);
                return this;
            }

            types = isArray ? types : [types];

            if (_.first(types) === '*' || value === null || value === undefined) {
                return this;
            }

            typeErrors = this.findErrorsForEachType(types, value);
            if (typeErrors && typeErrors.length) {
                this.handleTypeErrors(propName, typeErrors);
            }

        }
        return this;
    },

    findErrorsForEachType: function (types, value) {
        var errors = [];
        var i = 0;
        var hasValidType;
        for (i; i < types.length; i++) {
            errors.push(this.findErrorsForType(types[i], value));
        }
        hasValidType = _.any(errors, function (error) {
            return error === null;
        });
        if (!hasValidType) {
            return errors;
        }
        return null;
    },

    findErrorsForType: function (type, value) {
        if (typeof type === 'string') {
            if (type === 'array' && !this.checkIsArray(value)) {
                return {
                    key: 'array',
                    typeVal: 'array'
                };
            } else if (!this.checkTypeof(type, value))  {
                return {
                    key: 'type',
                    typeVal: type
                };
            }
        } else if (typeof type === 'function' && !this.checkIsInstanceOf(type, value)) {
            return {
                key: 'instanceof',
                typeVal: type
            };
        }
        return null;
    },

    checkTypeof: function (type, value) {
        return typeof value === type;
    },

    checkIsArray: function (value) {
        return _.isArray(value);
    },

    checkIsInstanceOf: function (type, value) {
        return value instanceof type;
    },

    handleTypeErrors: function (propName, typeErrors) {
        console.error('Property ' + this._getFormatedPropName(propName) + ' is not of the correct ' +
            'type: must be one of the following: ', _.pluck(typeErrors, 'typeVal'));
        return this;
    },

    handleSupportedError: function (propName) {
        console.error(this.supportedError(propName));
        return this;
    },

    /**
     * @param {string} propName
     * @returns {string}
     */
    supportedError: function (propName) {
        return "Property name '" + this._getFormatedPropName(propName) + "' not supported";
    },

    setIsSubPropForName: function (propName) {
        this.subPropName = propName;
        return this;
    },

    valuesIsObjectError: function () {
        if (this.subPropName) {
            console.error('Property ' + this.subPropName + ' must have an object for it\'s value');
        } else {
            console.error('Values must be an object');
        }
        return this;
    },

    _getFormatedPropName: function (propName) {
        if (this.parentProp) {
            propName = this.parentProp + '.' + propName;
        }
        return propName;
    },

    _getOptionsClone : function (parentProperty) {
        return _.extend({}, this._options, { parentProp: parentProperty });
    }

});



//////////////////
// WEBPACK FOOTER
// ./~/bunsen/helpers/checkProps.js
// module id = 166
// module chunks = 4 5 6 7 8 9 10 11 12 13 14 15 16 17 18 19 20 21 22 23 24 25 26 27 28 29 30 31 32 33 34 35 36 37 38 39 40 41 42 43 44 45 46 47 48 49 50 51 52 53 54